<template>
  <div v-if="ready">
    <base-form ref="form" :items="data" label-width="4em" @submit="onSubmit" />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import BaseForm from "@/components/BaseForm";
import { bindPhone, modifyPhone } from "@/http/account";
import { mixinForward } from "@/mixins/mixinForward";

export default {
  name: "Phone",
  components: { BaseForm },
  mixins: [mixinForward],
  data() {
    return {
      ready: false, // 防止页面在跳转到验证时内容闪现的问题
      data: [
        { name: "bindPhone" },
        { name: "telCode", type: 1, moduleType: true }
      ]
    };
  },
  computed: {
    ...mapGetters(["userInfo"]),
    phone() {
      return this.userInfo.security_telphone || "";
    }
  },
  mounted() {
    //已绑定手机后等级高度低（low），要先去安全验证
    if (this.userInfo.mode === "low" && this.phone.length > 0) {
      // 修改已绑定手机需要先进行安全验证
      this.$router.replace({
        path: this._anchor.verifier.path,
        query: {
          redirect: this.$route.fullPath,
          desc: "修改已绑定手机需要先进行安全验证"
        }
      });
    } else {
      this.ready = true;
    }
  },
  methods: {
    /**
     * @description 绑定手机/修改绑定手机
     * @param {object} formdata  - 表单对象值
     */
    onSubmit(formdata) {
      const parmas = {
        phone: formdata.bindPhone,
        code: formdata.telCode
      };
      let api = "";
      if (this.phone.length > 0) {
        api = modifyPhone(parmas);
      } else {
        api = bindPhone(parmas);
      }
      api
        .then(res => {
          if (res.rcode === 0) {
            this.success(res.rdesc, {
              countdown: true,
              callback: () => {
                if (this.forward) {
                  location.href = this.forward;
                } else {
                  //父级变为默认Profile
                  let query = this.$router.query;
                  if (query && query.path) {
                    this._anchor.bindPhone.meta.parent = "Profile";
                  }
                  let path =
                    query && query.path
                      ? query.path
                      : this._anchor.profile.path;

                  this.$router.replace({ path });
                }
              }
            });
          }
        })
        .finally(() => {
          this.$refs.form.disabled = false;
        });
    }
  }
};
</script>
